import {
  getCurrentBrand,
  type Brand,
  brandIsLm,
  brandIsPh,
  brandIsPh2,
  brandIsPw,
  isTestStage,
} from '@/shared/config/brand-by-target.mjs';
import {
  BRAND_THEMES,
  type BrandTheme,
} from '@/shared/config/brand-themes.mjs';
import {
  LANGUAGE_CONFIG,
  type LanguageConfig,
} from '@/shared/config/brand-languages.mjs';
import {
  TELEGRAM_BOT_NAME_CONFIG,
  type TelegramBotNameConfig,
} from '@/shared/config/brand-telegram-bots.mjs';

interface FullBrandTheme extends BrandTheme, LanguageConfig {
  currentBrand: Brand;
  telegramBot: TelegramBotNameConfig;
  isLm: boolean;
  isPw: boolean;
  isPh: boolean;
  isPh2: boolean;
  isDev: boolean;
}

const currentBrand: Brand = getCurrentBrand();

const FULL_BRAND_THEME: FullBrandTheme = {
  ...BRAND_THEMES[currentBrand],
  ...LANGUAGE_CONFIG[currentBrand],
  currentBrand,
  telegramBot: TELEGRAM_BOT_NAME_CONFIG[currentBrand],
  isLm: brandIsLm,
  isPw: brandIsPw,
  isPh: brandIsPh,
  isPh2: brandIsPh2,
  isDev: isTestStage,
};

const useBrandTheme = () => FULL_BRAND_THEME;

const CommonBrandData = {
  brandTheme: BRAND_THEMES[currentBrand],
  brandIsLm,
  brandIsPw,
  brandIsPh,
  brandIsPh2,
};

export function getThemeBrand() {
  return CommonBrandData.brandTheme;
}

export function getDefaultLanguage() {
  return LANGUAGE_CONFIG[currentBrand].defaultLanguage;
}

export function getAllowedLanguages() {
  return LANGUAGE_CONFIG[currentBrand].allowedLanguages;
}

export function getBrandData() {
  return CommonBrandData;
}

type ResolvableBannerKey =
  | 'bonusesBanner'
  | 'homeBanner'
  | 'motivationalBanner'
  | 'storeBanner'
  | 'cashbackBanner'
  | 'rebateBanner'
  | 'referralBanner'
  | 'installationGuideBanner';

export function resolveBannerAsset(
  bannerKey: ResolvableBannerKey,
  locale: string
) {
  const bannerAsset = getThemeBrand().assets?.[bannerKey];
  if (!bannerAsset) return null;
  return typeof bannerAsset === 'function' ? bannerAsset(locale) : bannerAsset;
}

export { useBrandTheme };
